import e from "../managers/braze-instance.js";
import g from "./content-cards-provider-factory.js";
export function subscribeToContentCardsUpdates(r) {
  if (!e.X()) return;
  const t = g.rr(),
    n = t.si(r);
  if (!t.ws()) {
    const r = e.cr();
    if (r) {
      const n = r.mr(() => {
        t.qs();
      });
      n && t.Cs(n);
    }
  }
  return n;
}
